import { render, staticRenderFns } from "./LabStatusBadge.vue?vue&type=template&id=d61923b8&scoped=true"
import script from "./LabStatusBadge.vue?vue&type=script&lang=js"
export * from "./LabStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./LabStatusBadge.vue?vue&type=style&index=0&id=d61923b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61923b8",
  null
  
)

export default component.exports